// src/Pages/Events.js
import React from "react";
import { Link } from "react-router-dom";
import { categories, products } from "../data/eventsData";

function Events() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Events</h1>
      {categories.map((cat) => (
        <section key={cat.id} id={cat.id}>
          <h2 className="text-xl font-semibold mb-4">{cat.label}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {products[cat.id].map((prod) => (
              <Link
                key={prod.id}
                to={`/product/${prod.id}`}
                state={prod}
                className="bg-white shadow-md rounded-lg p-4 hover:shadow-lg cursor-pointer"
              >
                <img src={prod.image} alt={prod.name} className="w-full h-40 object-cover rounded" />
                <h3 className="mt-2 font-medium">{prod.name}</h3>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default Events;